import { render, staticRenderFns } from "./VisitInfoV3.vue?vue&type=template&id=70ca0fda&"
import script from "./VisitInfoV3.vue?vue&type=script&lang=ts&"
export * from "./VisitInfoV3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports